import { useState, type FormEvent } from "react";
import Reveal from "./Reveal";

const SUBMIT_ADDR = "https://readdy.ai/api/form/daetrohtto0ceqqnh3u0";

type Status = { kind: "idle" | "success" | "error"; msg: string };

export default function Newsletter() {
  const [status, setStatus] = useState<Status>({ kind: "idle", msg: "" });
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = String(fd.get("website_alt") || "").trim();

    if (honeypot) {
      setStatus({ kind: "success", msg: "订阅成功，感谢关注，我们下期见。" });
      form.reset();
      return;
    }

    const email = String(fd.get("email") || "").trim();
    if (!email) {
      setStatus({ kind: "error", msg: "请先填写你的常用邮箱。" });
      return;
    }

    const payload = new URLSearchParams();
    payload.set("email", email);

    setLoading(true);
    setStatus({ kind: "idle", msg: "" });
    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const code = parsed?.code || "";
      const isSpam = /spam|form data is spam/i.test(responseText + serverMsg);

      if (res.ok && !isSpam && (code === "OK" || code === "")) {
        setStatus({ kind: "success", msg: "订阅成功，感谢关注，我们下期见。" });
        form.reset();
      } else {
        setStatus({
          kind: "error",
          msg: serverMsg || "订阅未能完成，请稍后再试或更换邮箱。",
        });
      }
    } catch {
      setStatus({ kind: "error", msg: "网络似乎开小差了，请稍后再试。" });
    } finally {
      setLoading(false);
    }
  }

  return (
    <section id="join" className="relative overflow-hidden bg-primary-500 py-16 md:py-20">
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-accent-400/40 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-primary-700/40 blur-3xl"></div>
      <div className="relative mx-auto max-w-[760px] px-4 text-center md:px-6">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-semibold text-background-50">
            <i className="ri-mail-send-line" aria-hidden="true"></i>
            吃瓜透视局 · 简报订阅
          </span>
          <h2 className="mt-5 font-heading text-3xl font-black leading-snug text-background-50 md:text-4xl">
            每周一期，把瓜田背后的门道讲给你听
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-background-50/85">
            订阅后可及时收到我们的热点拆解与防晕指南，内容不多但足够清醒，随时可退订。
          </p>
        </Reveal>

        <Reveal delay={120}>
          <form
            onSubmit={onSubmit}
            data-readdy-form="daetrohtto0ceqqnh3u0"
            className="mx-auto mt-8 flex max-w-xl flex-col gap-3 sm:flex-row"
          >
            <input
              type="email"
              name="email"
              autoComplete="email"
              placeholder="输入你的邮箱地址"
              aria-label="邮箱地址"
              className="h-12 flex-1 rounded-md border border-background-50/30 bg-background-50/95 px-4 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-background-50"
            />
            {/* honeypot */}
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="chiguax-hp" />
            <button
              type="submit"
              disabled={loading}
              className="h-12 whitespace-nowrap rounded-md bg-foreground-950 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800 disabled:opacity-70"
            >
              {loading ? "提交中…" : "订阅简报"}
            </button>
          </form>
          {status.kind === "success" && (
            <p className="mt-4 text-sm font-medium text-background-50" role="status">
              <i className="ri-checkbox-circle-fill mr-1" aria-hidden="true"></i>
              {status.msg}
            </p>
          )}
          {status.kind === "error" && (
            <p className="mt-4 text-sm font-medium text-accent-200" role="alert">
              <i className="ri-error-warning-fill mr-1" aria-hidden="true"></i>
              {status.msg}
            </p>
          )}
        </Reveal>

        <Reveal delay={200}>
          <p className="mt-5 flex flex-wrap items-center justify-center gap-4 text-xs text-background-50/70">
            <span className="flex items-center gap-1">
              <i className="ri-lock-line" aria-hidden="true"></i>
              我们尊重你的隐私，不发送无关打扰
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-close-circle-line" aria-hidden="true"></i>
              随时可一键退订
            </span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}